export default __webpack_public_path__ + "static/media/anon-request.1ca145eb.svg";